import { BannerContextProvider } from "contexts/BannerContext";
import { CompaniesContextProvider } from "contexts/CompaniesContext";
import { PageWidthViewContextProvider } from "contexts/PageWidthViewContext";
import { ProductsContextProvider } from "contexts/ProductsContext";
import { PublicApiServiceProvider } from "contexts/PublicApiServiceProvider";
import { SpendInsightsProductSettingsContextProvider } from "contexts/SpendInsightsProductSettingsContext";
import { FeatureStatusContextProvider } from "portal-ui-remote/FeatureStatusContext";
import { IntegrationPageNameContextProvider } from "portal-ui-remote/IntegrationPageNameContext";
import { UserStateContextProvider } from "portal-ui-remote/UserStateContext";
import React, { PropsWithChildren } from "react";

import ErrorBoundary from "components/ErrorBoundary";
import NavContainer from "components/NavContainer";

const Layout = ({ children }: PropsWithChildren) => (
  <PublicApiServiceProvider>
    <PageWidthViewContextProvider>
      <BannerContextProvider>
        <IntegrationPageNameContextProvider>
          <FeatureStatusContextProvider>
            <ProductsContextProvider>
              <CompaniesContextProvider>
                <UserStateContextProvider>
                  <SpendInsightsProductSettingsContextProvider>
                    <NavContainer>
                      <ErrorBoundary>{children}</ErrorBoundary>
                    </NavContainer>
                  </SpendInsightsProductSettingsContextProvider>
                </UserStateContextProvider>
              </CompaniesContextProvider>
            </ProductsContextProvider>
          </FeatureStatusContextProvider>
        </IntegrationPageNameContextProvider>
      </BannerContextProvider>
    </PageWidthViewContextProvider>
  </PublicApiServiceProvider>
);

export default Layout;
